export enum Tags {
  PROJECTS = "Projects",
  TASKS = "Tasks",
  COLUMNS = "Columns",
}
